import React from "react";
import PropTypes from "prop-types";
import {makeStyles} from "@material-ui/core/styles";
import useConfig from "./qnect-ui/qnect-config";
import {ReactComponent as RedXMark} from "../assets/RedXMark.svg";
import Dialog from "./custom/dialog";
import QnectButton from "./qnect-ui/qnect-button";

const useStyles = makeStyles(theme => ({
    dialog: {
        '& .MuiDialog-paper': {
            [theme.breakpoints.between('sm', 'md')]: {
                padding: '14px 60px 32px'
            },
            [theme.breakpoints.up('lg')]: {
                padding: '14px 76px 52px',
                width: '630px'
            }
        },
        textAlign: 'center'
    },
    iconDiv: {
        marginTop: '32px'
    },
    title: {
        fontFamily: 'Stag-Medium',
        fontSize: '24px',
        color: '#003da5',
        lineHeight: '36px',
        marginTop: '16px'
    },
    content: {
        marginTop: '40px',
        marginBottom: '40px',
        fontFamily: 'Inter-Regular',
        fontSize: '18px',
        whiteSpace: 'pre-wrap'
    }
}));

export default function LinkValidationModal(props) {
    const {
        open,
        messageKey,
        onClose
    } = props;

    const cfg = useConfig();
    const classes = useStyles();

    return (
        <Dialog className={classes.dialog} open={open} disableBackdropClick={true} disableEscapeKeyDown={true}>
            <div className={classes.iconDiv}><RedXMark/></div>
            <div className={classes.title}>{cfg(messageKey, 'title')}</div>
            <div className={classes.content}>{cfg(messageKey, 'message')}</div>
            <div>
                <QnectButton field='ok' onClick={onClose}/>
            </div>
        </Dialog>
    );
}

LinkValidationModal.propTypes = {
    open: PropTypes.bool,
    messageKey: PropTypes.string,
    onClose: PropTypes.func
};
